import theme from "@/theme";
import { SVGProps } from "react";
const EmojiSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill={theme.palette.custom.mainBlue}
      d="M8 9.5C8 8.119 8.672 7 9.5 7S11 8.119 11 9.5 10.328 12 9.5 12 8 10.881 8 9.5Zm6.5 2.5c.828 0 1.5-1.119 1.5-2.5S15.328 7 14.5 7 13 8.119 13 9.5s.672 2.5 1.5 2.5ZM12 16c-2.224 0-3.021-2.227-3.051-2.316l-1.897.633c.05.15 1.271 3.684 4.949 3.684s4.898-3.533 4.949-3.684l-1.896-.638c-.033.095-.83 2.322-3.053 2.322L12 16Zm10.25-4.001c0 5.652-4.598 10.25-10.25 10.25S1.75 17.652 1.75 12 6.348 1.75 12 1.75 22.25 6.348 22.25 12v-.001Zm-2 0c0-4.549-3.701-8.25-8.25-8.25-4.549 0-8.25 3.702-8.25 8.251 0 4.549 3.701 8.25 8.25 8.25 4.549 0 8.25-3.701 8.25-8.25v-.001Z"
    />
  </svg>
);
export default EmojiSvg;
